import { useEffect } from "react";
import { useNavigate } from "react-router";
import { signOut } from "../../data/firebase/auth";
import {
  analyticsLogEvent,
  analyticsReportError,
} from "../../data/firebase/analytics";

export default function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    signOut()
      .then(() => {
        analyticsLogEvent("logout");
        navigate("/");
      })
      .catch(analyticsReportError);
  });

  return <></>;
}
